// src/pages/DrobnoPohistvo.tsx
import CategoryPage from './CategoryPage';

const DrobnoPohistvo = () => {
  const subcategories = [
    {
      title: "Muvet Panca",
      imageSrc: "https://images.unsplash.com/photo-1618220179428-22790b461013?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/muvet-panca"
    },
    {
      title: "Tuareg Vases",
      imageSrc: "https://images.unsplash.com/photo-1615529182904-14819c35db37?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/tuareg-vases"
    },
    {
      title: "Veloce Stool",
      imageSrc: "https://images.unsplash.com/photo-1588866413115-47473525bfc4?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/veloce-stool"
    },
    {
      title: "Vanity Stool",
      imageSrc: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/vanity-stool"
    },
    {
      title: "Edmund Sgabello",
      imageSrc: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/edmund-sgabello"
    },
    {
      title: "Basket",
      imageSrc: "https://images.unsplash.com/photo-1626806787461-102c1a7f1c62?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/basket"
    },
    {
      title: "Edmund Table",
      imageSrc: "https://images.unsplash.com/photo-1604061986761-d9d0cc41b0d1?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/edmund-table"
    },
    {
      title: "Marble Tray",
      imageSrc: "https://images.unsplash.com/photo-1622398925373-3f91b1ff780f?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/marble-tray"
    },
    {
      title: "Milord porta asciugamani",
      imageSrc: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/milord-porta-asciugamani"
    },
    {
      title: "Piegami Stool",
      imageSrc: "https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/piegami-stool"
    },
    {
      title: "Ghost Stool",
      imageSrc: "https://images.unsplash.com/photo-1551298370-9d3d53740c72?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/ghost-stool"
    },
    {
      title: "Bibò Scala",
      imageSrc: "https://images.unsplash.com/photo-1567016432779-094069958ea5?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/bibo-scala"
    },
    {
      title: "Uilli Stair",
      imageSrc: "https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/uilli-stair"
    },
    {
      title: "Compasso",
      imageSrc: "https://images.unsplash.com/photo-1589584649628-b597067e07a3?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/compasso"
    },
    {
      title: "Sarong Stool",
      imageSrc: "https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/sarong-stool"
    },
    {
      title: "Ordina Stool",
      imageSrc: "https://images.unsplash.com/photo-1503602642458-232111445657?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/ordina-stool"
    },
    {
      title: "Tancho Stool",
      imageSrc: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/tancho-stool"
    },
    {
      title: "Koi Stool",
      imageSrc: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/koi-stool"
    },
    {
      title: "Tricky stool",
      imageSrc: "https://images.unsplash.com/photo-1579656381253-c2e57a7d7c81?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/tricky-stool"
    },
    {
      title: "Twister Stool",
      imageSrc: "https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/twister-stool"
    },
    {
      title: "Portami",
      imageSrc: "https://images.unsplash.com/photo-1617104678098-de229db51175?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/portami"
    },
    {
      title: "Snake Tree",
      imageSrc: "https://images.unsplash.com/photo-1586798532888-f52f05e261ee?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/snake-tree"
    },
    {
      title: "Tree",
      imageSrc: "https://images.unsplash.com/photo-1584458313453-5589fcbb6233?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/tree"
    },
    {
      title: "Comoda",
      imageSrc: "https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/comoda"
    },
    {
      title: "Arya",
      imageSrc: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/arya"
    },
    {
      title: "Zen Stool",
      imageSrc: "https://images.unsplash.com/photo-1528698827591-e19ccd7bc23d?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/zen-stool"
    },
    {
      title: "Adirondack",
      imageSrc: "https://images.unsplash.com/photo-1533090161767-e6ffed986c88?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/adirondack"
    },
    {
      title: "Invilla Stool",
      imageSrc: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?auto=format&fit=crop&q=80",
      url: "/drobno-pohistvo/invilla-stool"
    }
  ];

  return (
    <CategoryPage
      title="Drobno pohištvo"
      description="Popestrite vašo kopalnico z našim izborom drobnega pohištva, ki združuje funkcionalnost, stil in kvaliteto."
      heroImage="https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&q=80"
      subcategories={subcategories}
    />
  );
};

export default DrobnoPohistvo;